export const MAP_API_KEY = 'AIzaSyAQxxxs_1ID9wDZBRDnG511zmJjzeGryCM';
export const csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content');
